import React from "react";
import imageJoan from "../../Assets/meetjoan.webp";
import { useTranslation } from "react-i18next";
import { AiOutlineArrowRight } from "react-icons/ai";
import { Link, useLocation } from "react-router-dom";

const MeetJoanHome = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const isEnglish = location.pathname.startsWith("/en");
    const basePath = isEnglish ? "/en" : "";
    
   return (
      <section className="meet-container" id="aboutme">
         {/* Columna Izquierda: Imagen y Stats */}
         <div className="imageColumn">
            <div className="imageWrapper">
               <img
                  src={imageJoan}
                  alt="Joan Company - Creador de Contenido FPV"
                  title="Joan Company - Creador de Contenido FPV"
                  className="meet-profileImage"
               />
               <div className="statsOverlay"></div>
            </div>
         </div>

         {/* Columna Derecha: Texto */}
         <div className="contentColumn">
            <div className="textContent">
               <h2 className="meet-title">{t("meet_joan")}</h2>
               <p className="meet-description">{t("meet_desc_1")}</p>
               <p className="meet-description">{t("meet_desc_2")}</p>
               <p className="meet-description">{t("meet_desc_3")}</p>
            </div>
            <Link
               to={`${basePath}/sobre-mi`}
               className="learn-more-link"
               title={t("name")}
            >
               {t("learn_more")} <AiOutlineArrowRight />
            </Link>
         </div>
      </section>
   );
};

export default MeetJoanHome;
